import { render, staticRenderFns } from "./BasicSlider.vue?vue&type=template&id=981f7008&scoped=true&"
import script from "./BasicSlider.vue?vue&type=script&lang=js&"
export * from "./BasicSlider.vue?vue&type=script&lang=js&"
import style0 from "./BasicSlider.vue?vue&type=style&index=0&id=981f7008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981f7008",
  null
  
)

export default component.exports